<div class="footer">    
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-5 col-lg-3 footer__copyright">
                <p>Copyright @ 2023, ATRAM. All rights reserved.</p>
            </div>
            
            <div class="col-12 col-md-7 col-lg-5 offset-lg-2 offset-xl-4 footer__text">
                <div class="container">
                    <div class="row">
                        <div class="col-4">
                            <p (click)="navigateUrl('/footer-pages/privacy-policy')">
                                PRIVACY POLICY
                            </p>
                        </div>
                        <div class="col-6">
                            <p (click)="navigateUrl('/footer-pages/service-management')">
                                ONLINE SERVICE AGREEMENT 
                            </p>
                        </div>
                        <div class="col-2">
                            <p (click)="navigateUrl('/footer-pages/security')">
                                SECURITY 
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>